// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___24TYg","textarea":"styles__textarea___1bcph","characterCount":"styles__characterCount___2FIso"};